<template>
<b-navbar toggleable="md" type="dark" variant="info">

  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  <b-collapse is-nav id="nav_collapse">

    <b-navbar-nav>
      <b-nav-item v-on:click="setActive('about')" v-bind:active="activeItem === 'home'" to="/">Home</b-nav-item>
      <b-nav-item href="http://www.linkedin.com/in/shaneblaser" target="_blank">LinkedIn</b-nav-item>
      <b-nav-item href="/static/ShaneBlaserResume.pdf" target="_blank">Resume</b-nav-item>
      <b-nav-item href="mailto:shaneblaser@gmail.com" target="_top">eMail</b-nav-item>
    <b-nav-item-dropdown right>
        <!-- Using button-content slot -->
        <template slot="button-content">
          <em>Projects</em>
        </template>
        <b-dropdown-item href="http://shaneblaser.com/weewx" target="_blank">Weather Station</b-dropdown-item>
        <b-dropdown-item v-on:click="setActive('solar')" v-bind:active="activeItem === 'solar'" to="solarGraph">Solar Battery Monitor</b-dropdown-item>
        <b-dropdown-item v-on:click="setActive('j2Demo')" v-bind:active="activeItem === 'j2Demo'" to="j2Demo">j2Demo</b-dropdown-item>
    </b-nav-item-dropdown>
    </b-navbar-nav>

    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown text="Lang" right>
        <b-dropdown-item href="#">EN</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

  </b-collapse>
</b-navbar>
</template>

<script>
export default {
  data () {
    return { activeItem: 'home' }
  },
  mounted: function () {
    console.log('NavBar mounted')
    console.log('active item: ', this.activeItem)
  },
  methods: {
    isActive: function (menuItem) {
      return this.activeItem === menuItem
    },
    setActive: function (menuItem) {
      this.activeItem = menuItem // no need for Vue.set()
      console.log('active item: ', this.activeItem)
    }
  }
}
</script>
<style>
.bg-info {
    background-color: #5c17b8!important;
}
.dropdown-menu {
    background-color: #a38ee5!important;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue